export const camelize = function(text) {
  return text.replace(/^([A-Z])|[\s-_]+(\w)/g, function(_match, p1, p2, _offset) {
    if (p2) return p2.toUpperCase();
    return p1.toLowerCase();
  });
};
